module.exports = __webpack_public_path__ + "img/USDT.97d83fd8.svg";